// src/components/seasonal/TrialPromptPopup.js
import React from 'react';
import { Link } from 'react-router-dom';

const FEATURES = [
  { icon: '🔍', title: 'Search 75,000+ Keywords', desc: 'See Golden Score, competition and popularity for any TPT keyword instantly.' },
  { icon: '📈', title: 'Live Rank Tracking',       desc: 'See exactly where your products rank and watch them climb over time.' },
  { icon: '🏆', title: 'Competitor Analysis',      desc: 'See what keywords top-ranking products use and reverse-engineer their success.' },
  { icon: '✨', title: 'AI Listing Optimiser',     desc: 'Import any TPT product URL and get a rewritten, SEO-ready description in seconds.' },
  { icon: '🌟', title: 'Chrome Extension',         desc: 'Analyse any TPT page instantly without leaving the site.' },
];

const TrialPromptPopup = ({ onClose, accentColor = '#2563eb', accentDark = '#1e40af', accentLight = '#eff6ff', accentBorder = '#bfdbfe' }) => (
  <div
    onClick={onClose}
    style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.65)',
      zIndex: 2000,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '16px',
      animation: 'tpFadeIn 0.2s ease',
    }}
  >
    <style>{`
      @keyframes tpFadeIn  { from { opacity: 0; } to { opacity: 1; } }
      @keyframes tpSlideUp { from { transform: translateY(24px); opacity: 0; } to { transform: translateY(0); opacity: 1; } }
      .tp-popup { animation: tpSlideUp 0.25s ease; }
      .tp-primary-btn:hover { transform: translateY(-1px); }
      .tp-secondary-btn:hover { background: #f1f5f9 !important; }
    `}</style>

    <div
      className="tp-popup"
      onClick={e => e.stopPropagation()}
      style={{
        background: 'white',
        borderRadius: '20px',
        padding: '36px 32px',
        maxWidth: '500px',
        width: '100%',
        boxShadow: '0 25px 60px rgba(0,0,0,0.3)',
        position: 'relative',
        maxHeight: '90vh',
        overflowY: 'auto',
        fontFamily: "'DM Sans', Helvetica, Arial, sans-serif",
      }}
    >
      {/* Close button */}
      <button
        onClick={onClose}
        style={{
          position: 'absolute', top: '14px', right: '14px',
          background: '#f1f5f9', border: 'none', borderRadius: '50%',
          width: '30px', height: '30px', cursor: 'pointer',
          fontSize: '14px', color: '#64748b', lineHeight: '30px', textAlign: 'center',
        }}
      >✕</button>

      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '24px' }}>
        <div style={{ fontSize: '40px', marginBottom: '10px' }}>🚀</div>
        <div style={{ fontFamily: 'Sora, sans-serif', fontWeight: 900, fontSize: '20px', color: '#0f172a', marginBottom: '6px' }}>
          While you wait for your report...
        </div>
        <div style={{ fontSize: '14px', color: '#64748b', lineHeight: 1.6 }}>
          Did you know our app can do all of this for <em>any</em> keyword — not just the ones in the report?
        </div>
      </div>

      {/* Features */}
      <div style={{ marginBottom: '20px' }}>
        {FEATURES.map(({ icon, title, desc }) => (
          <div key={title} style={{ display: 'flex', gap: '12px', marginBottom: '14px', alignItems: 'flex-start' }}>
            <div style={{
              fontSize: '20px', flexShrink: 0,
              background: accentLight, border: `1px solid ${accentBorder}`,
              borderRadius: '8px', width: '36px', height: '36px',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>{icon}</div>
            <div>
              <div style={{ fontWeight: 700, fontSize: '14px', color: '#0f172a', marginBottom: '2px' }}>{title}</div>
              <div style={{ fontSize: '13px', color: '#64748b', lineHeight: 1.5 }}>{desc}</div>
            </div>
          </div>
        ))}
      </div>

      {/* No subscription badge */}
      <div style={{
        background: '#f0fdf4', border: '1px solid #bbf7d0',
        borderRadius: '10px', padding: '12px 16px',
        marginBottom: '20px', textAlign: 'center',
      }}>
        <div style={{ fontWeight: 800, fontSize: '14px', color: '#14532d', marginBottom: '2px' }}>
          💳 No subscription. Ever.
        </div>
        <div style={{ fontSize: '12px', color: '#15803d' }}>
          One payment. Lifetime access. Yours forever — no monthly fees, no renewals.
        </div>
      </div>

      {/* CTAs */}
      <Link
        to="/app"
        className="tp-primary-btn"
        style={{
          display: 'block', width: '100%', textAlign: 'center',
          background: `linear-gradient(135deg, ${accentColor}, ${accentDark})`,
          color: 'white', fontFamily: 'Sora, sans-serif',
          fontWeight: 800, fontSize: '15px',
          padding: '15px', borderRadius: '12px',
          textDecoration: 'none', marginBottom: '10px',
          boxShadow: '0 4px 14px rgba(37,99,235,0.25)',
          transition: 'transform 0.15s',
          boxSizing: 'border-box',
        }}
      >
        🚀 Try Free for 1 Hour — No Card Needed
      </Link>

      <a
        href="https://www.teacherspayteachers.com/Product/TPT-Seller-SEO-Listing-Optimizer-App-Create-Titles-Descriptions-SEO-Ranking-13645689"
        target="_blank"
        rel="noopener noreferrer"
        className="tp-secondary-btn"
        style={{
          display: 'block', width: '100%', textAlign: 'center',
          background: 'white', border: '1.5px solid #e2e8f0',
          color: '#374151', fontFamily: 'Sora, sans-serif',
          fontWeight: 600, fontSize: '13px',
          padding: '13px', borderRadius: '12px',
          textDecoration: 'none', marginBottom: '12px',
          transition: 'background 0.15s',
          boxSizing: 'border-box',
        }}
      >
        Or get lifetime access on TPT →
      </a>

      <div style={{ textAlign: 'center', fontSize: '11px', color: '#94a3b8' }}>
        140+ five-star reviews · 400+ active sellers · No card needed for trial
      </div>
    </div>
  </div>
);

export default TrialPromptPopup;